// extracted by mini-css-extract-plugin
export default {"text":"PunchupConfirmDialog_text__2io06","contentWrapper":"PunchupConfirmDialog_contentWrapper__mxLXL","loadingOverlay":"PunchupConfirmDialog_loadingOverlay__4728Y"};